import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { captureAttribution } from '@/lib/attribution'
import { listenForDemoRequestClicks, listenForWhatsAppClicks } from '@/lib/analytics'

/** Persists first-touch UTM / click IDs and full query string for the session. */
export function AttributionTracker() {
  const location = useLocation()
  const trackedPageViewPath = useRef<string | null>(null)

  useEffect(() => listenForWhatsAppClicks(), [])
  useEffect(() => listenForDemoRequestClicks(), [])

  useEffect(() => {
    captureAttribution()
    const pageViewPath = `${location.pathname}${location.search}`

    if (trackedPageViewPath.current === pageViewPath) {
      return
    }

    if (trackedPageViewPath.current === null) {
      trackedPageViewPath.current = pageViewPath
      return
    }

    trackedPageViewPath.current = pageViewPath

    // Meta Pixel virtual pageview
    if (typeof window !== 'undefined' && typeof (window as any).fbq === 'function') {
      const activeMetaPixelId = (window as any).__activeMetaPixelId
      if (activeMetaPixelId) {
        ;(window as any).fbq('trackSingle', activeMetaPixelId, 'PageView')
      }
    }

    // Clarity virtual pageview, required for SPA session stitching
    if (typeof (window as any).clarity === 'function') {
      ;(window as any).clarity('set', 'current_url', location.pathname + location.search)
      ;(window as any).clarity('event', 'pageview')
    }
  }, [location.pathname, location.search, location.hash])

  return null
}
